<script setup>
/* istanbul ignore file */
import { onMounted } from 'vue';
import Toast from '@atomic-ui/toast';
import { useOncePerSession } from '@composables/utils/useOncePerSession';
import { useOnScrollStart } from '@composables/utils/useOnScrollStart';
import { tagShopMoreToastLinkClick } from '../../../features/analytics/shopMore';

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  promoCode: {
    type: String,
    required: true,
  },
  priceTypeText: {
    type: String,
    required: true,
  },
});

const { hasBeenUsed } = useOncePerSession('shop-more');
const { hasBeenUsed: hasBeenUsedLinkEvent } = useOncePerSession('shop-more-toast:link-clicked');

function handleClick() {
  if (!hasBeenUsedLinkEvent.value) {
    tagShopMoreToastLinkClick(props.promoCode, props.priceTypeText);
    hasBeenUsedLinkEvent.value = true;
  }
}

function showToast() {
  return Toast({
    message: props.label,
    showCloseIcon: true,
    ctaText: 'Shop now',
    ctaLink: props.url,
    duration: 0,
    placement: 'bottom',
    onCtaClick: handleClick,
  });
}

onMounted(() => {
  if (!hasBeenUsed.value) {
    useOnScrollStart(() => {
      showToast();
      hasBeenUsed.value = true;
    });
  }
});
</script>
<style lang="scss">
.toast-content {
  text-align: left;
  .cta-link {
    flex: none;
    text-align: center;
  }
}
</style>
